import { lazy } from "react";
import AuthLayout from "../layouts/AuthLayout";
import UserLayout from "../layouts/UserLayout";

const FormPostal = lazy(() => import("../pages/BookingForm/FormPostal"));
const ForgotPassword = lazy(() => import("../pages/auth/ForgotPassword"));
const Login = lazy(() => import("../pages/auth/Login"));
const SignUp = lazy(() => import("../pages/auth/SignUp"));
const VerifyOtp = lazy(() => import("../pages/auth/VerifyOtp"));
const PasswordReset = lazy(() => import("../pages/auth/PasswordReset"));
const CheckOut = lazy(() => import("../pages/CheckOut"));
const Professional = lazy(() => import("../pages/BookingForm/Professional"));
const MyProfile = lazy(() => import("../pages/Customer/MyProfile/MyProfile"));
const Dashboard = lazy(() => import("../pages/Customer/Dashboard/Dashboard"));
const Booking = lazy(() => import("../pages/Customer/MyBookings/Booking"));
const BookingDetails = lazy(() => import("../pages/Customer/MyBookings/BookingDetails"));
const Orders = lazy(() => import("../pages/Customer/MyOrders/Orders"));
const OrderDetails = lazy(() => import("../pages/Customer/MyOrders/OrderDetails"));
const NoContentPage = lazy(() => import("../components/common/NoContentPage"));
const OrderPending = lazy(() => import("../pages/Customer/MyOrders/OrderPending"));
const OrderBookingMainPage = lazy(() =>
  import("../pages/BookingForm/GeneralRegularBooking/OrderBookingMainPage")
);
const Review = lazy(() => import("../pages/Customer/ReviewRating/Review"));
const ThankYouPageReview = lazy(() =>
  import("../pages/Customer/ReviewRating/ThankYouPageReview")
);
const OrderThankYou = lazy(() => import("../pages/Customer/MyOrders/OrderThankYou"));
const CMSVerifier = lazy(() => import("../pages/BookingForm/CMSVerifier/CMSVerifier"));
const LandingPage = lazy(() =>
  import("../components/common/LandingPage/LandingPage")
);

const AuthLayoutFunc = (comp) => {
  return <AuthLayout>{comp}</AuthLayout>;
};
const UserLayoutFunc = (comp) => {
  return <UserLayout>{comp}</UserLayout>;
};

const routes = [
  {
    path: "/login",
    element: AuthLayoutFunc(<Login />),
    type: "auth",
    role: [],
  },
  {
    path: "/signup",
    element: AuthLayoutFunc(<SignUp />),
    type: "auth",
    role: [],
  },
  {
    path: "/forgot-password",
    element: AuthLayoutFunc(<ForgotPassword />),
    type: "auth",
    role: [],
  },
  {
    path: "/Verify-otp",
    element: AuthLayoutFunc(<VerifyOtp />),
    type: "auth",
    role: [],
  },
  {
    path: "/cms-verifier",
    element: AuthLayoutFunc(<CMSVerifier />),
    type: "auth",
    role: [],
  },
  {
    path: "/reset-password",
    element: AuthLayoutFunc(<PasswordReset />),
    type: "auth",
    role: [],
  },
  {
    path: "/",
    element: AuthLayoutFunc(<LandingPage />),
    type: "auth",
    role: [],
  },
  {
    path: "/formpostal",
    element: AuthLayoutFunc(<FormPostal />),
    role: [],
  },
  {
    path: "/order-booking",
    element: AuthLayoutFunc(<OrderBookingMainPage />),
    role: [],
  },
  {
    path: "/checkout",
    element: AuthLayoutFunc(<CheckOut />),
    type: "non-protected",
    role: [],
  },
  {
    path: "/professional",
    element: AuthLayoutFunc(<Professional />),
    role: [],
  },
  {
    path: "/dashboard",
    element: UserLayoutFunc(<Dashboard />),
    type: "protected",
    role: ["customer"],
  },
  {
    path: "/booking",
    element: UserLayoutFunc(<Booking />),
    type: "protected",
    role: ["customer"],
  },
  {
    path: "/booking-details/:id",
    element: UserLayoutFunc(<BookingDetails />),
    type: "protected",
    role: ["customer"],
  },
  {
    path: "/my-orders",
    element: UserLayoutFunc(<Orders />),
    type: "protected",
    role: ["customer"],
  },
  {
    path: "/order-details/:id",
    element: UserLayoutFunc(<OrderDetails />),
    type: "non-protected",
    role: ["customer"],
  },
  {
    path: "/order-thank-you",
    element: UserLayoutFunc(<OrderThankYou />),
    type: "protected",
    role: ["customer"],
  },
  {
    path: "/orderPending",
    element: UserLayoutFunc(<OrderPending />),
    type: "protected",
    role: ["customer"],
  },
  {
    path: "/my-profile",
    element: UserLayoutFunc(<MyProfile />),
    type: "protected",
    role: ["customer"],
  },
  {
    path: "/review/:id",
    element: UserLayoutFunc(<Review />),
    type: "non-protected",
    role: ["customer"],
  },
  {
    path: "/review/thank-you",
    element: UserLayoutFunc(<ThankYouPageReview />),
    type: "protected",
    role: ["customer"],
  },
  {
    path: "*",
    element: <NoContentPage />,
  },
];

export default routes;
